var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.6 7.714h13.3V5.81H4.6zm0 13.334q-.784 0-1.342-.56a1.84 1.84 0 0 1-.558-1.345V5.81q0-.786.558-1.346.559-.56 1.342-.56h.95v-.952q0-.405.273-.678A.92.92 0 0 1 6.5 2q.404 0 .677.274a.92.92 0 0 1 .273.678v.953h7.6v-.953q0-.405.273-.678A.92.92 0 0 1 16 2q.404 0 .677.274a.92.92 0 0 1 .273.678v.953h.95q.784 0 1.342.56.558.558.558 1.345v4.452q0 .405-.273.678a.92.92 0 0 1-.677.274.92.92 0 0 1-.677-.274.92.92 0 0 1-.273-.678v-.643H4.6v9.524h5.51q.404 0 .677.274a.92.92 0 0 1 .273.678q0 .405-.273.679a.92.92 0 0 1-.677.274zM16.95 22q-1.971 0-3.36-1.393-1.39-1.392-1.39-3.369 0-1.975 1.39-3.369 1.389-1.393 3.36-1.393t3.36 1.393q1.39 1.393 1.39 3.37 0 1.976-1.39 3.368Q18.922 22 16.95 22m.475-4.952v-2.19a.46.46 0 0 0-.143-.334.455.455 0 0 0-.665 0 .46.46 0 0 0-.142.333v2.167q0 .19.071.369a1 1 0 0 0 .214.321l1.449 1.453a.455.455 0 0 0 .665 0 .46.46 0 0 0 0-.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClock);
export default __webpack_public_path__ + "static/media/calendar_clock.c2648ac35e6378f5e67780dd964c99dd.svg";
export { ForwardRef as ReactComponent };